import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Stack,
  Typography,
  IconButton,
  Divider,
} from "@mui/material";
import DepositForm from "../Pages/Users/Components/DepositForm";
import UserSavingsForm from "../Pages/Users/Components/UserSavingsForm";
import { grey } from "@mui/material/colors";
import FundPoolForm from "../Pages/PoolFund/FundPoolForm";
import WithdrawPoolForm from "../Pages/Users/Components/WithdrawPoolForm";
import CloseIcon from "@mui/icons-material/Close";
import ApplyLoanForm from "../Pages/Users/Components/UserLoan/ApplyLoanForm";
import PurchaseAirtimeForm from "../Pages/Users/Components/PurchaseAirtimeForm";
import BoostShares from "../Pages/Shares/component/BoostShares";
import LoanRepaymentTabs from "../Pages/Users/Components/UserLoan/LoanRepaymentTabs";
import AddKinForm from "../Pages/Users/Components/UserKin/AddKinForm";
import EditKinForm from "../Pages/Users/Components/UserKin/EditKinForm";
import DeleteKinForm from "../Pages/Users/Components/UserKin/DeleteKinForm";
import GuarantorApprovalForm from "../Pages/Users/Components/Guarantors/GuarantorApprovalForm";
import RepayLoanForm from "../Pages/Users/Components/UserLoan/RepayLoanForm";
import CreateBankAcount from "../Pages/Settings/CreateBankAcount";
import GuarantorNominationForm from "../Pages/Users/Components/Guarantors/GuarantorNominationForm";
import UpdateUser from "../Pages/Users/Components/UpdateUser";
import UserSmsForm from "../Pages/Users/Components/UserSms/UserSmsForm";
import CreatePoolBasket from "../Pages/PoolFund/CreatePoolBasket";
import ExitUserForm from "../Pages/Users/Components/UserActions/ExitUserForm";
import BlockUserForm from "../Pages/Users/Components/UserActions/BlockUserForm";
import UnblockUserForm from "../Pages/Users/Components/UserActions/UnblockUserForm";
import AddAccountForm from "../Pages/Users/Components/UserAccounts/AddAccountForm";
import WithdrawApprovalForm from "../Pages/PoolFund/Components/WithdrawApprovalForm";
import TransactionWithdrawApprovalForm from "../Pages/Transactions/Component/TransactionWithdrawApprovalForm";

const ActionDialog = ({
  open,
  onClose,
  dialogType,
  dialogLabel,
  user,
  onSuccess,
  data,
  setUser,
}) => {
  const renderForm = () => {
    switch (dialogType) {
      case "deposit":
        // Pass onSuccess to the form so it can trigger a data refresh
        return (
          <DepositForm user={user} onClose={onClose} onSuccess={onSuccess} />
        );
      case "save":
        return (
          <UserSavingsForm
            user={user}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        );
      case "pool_fund":
        return (
          <FundPoolForm user={user} onClose={onClose} onSuccess={onSuccess} />
        );
      case "withdraw_pool_fund":
        return (
          <WithdrawPoolForm
            user={user}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        );
      case "apply_loan":
        return (
          <ApplyLoanForm user={user} onClose={onClose} onSuccess={onSuccess} />
        );
      case "airtime":
        return (
          <PurchaseAirtimeForm
            user={user}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        );
      case "boost_shares":
        return (
          <BoostShares user={user} onClose={onClose} onSuccess={onSuccess} />
        );
      case "sell_shares":
        return (
          <BoostShares user={user} onClose={onClose} onSuccess={onSuccess} />
        );
      case "repay_loan":
        return (
          <LoanRepaymentTabs
            loan={data}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        );
      case "repay":
        return (
          <RepayLoanForm user={user} onClose={onClose} onSuccess={onSuccess} />
        );
      case "edit_profile":
        return (
          <UpdateUser
            user={user}
            setUser={setUser}
            onClose={onClose}
            onUpdated={onSuccess}
          />
        );
      case "add_kin":
        return (
          <AddKinForm user={user} onClose={onClose} onSuccess={onSuccess} />
        );
      case "edit_kin":
        return (
          <EditKinForm
            user={user}
            data={data}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        );
      case "delete_kin":
        return (
          <DeleteKinForm data={data} onClose={onClose} onSuccess={onSuccess} />
        );
      case "approve_guarantor":
        return (
          <GuarantorApprovalForm
            data={data}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        );
      case "create_bank_account":
        return (
          <CreateBankAcount
            user={user}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        );
      case "nominate_guarantor":
        return (
          <GuarantorNominationForm
            user={user}
            data={data}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        );
      case "send_sms":
        return (
          <UserSmsForm user={user} onClose={onClose} onSuccess={onSuccess} />
        );
      case "create_basket":
        return (
          <CreatePoolBasket
            user={user}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        );
      case "exit":
        return (
          <ExitUserForm user={user} onClose={onClose} onSuccess={onSuccess} />
        );
      case "block":
        return (
          <BlockUserForm user={user} onClose={onClose} onSuccess={onSuccess} />
        );
      case "unblock":
        return (
          <UnblockUserForm
            user={user}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        );
      case "reset_pin":
        return (
          <UnblockUserForm
            user={user}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        );
      case "pool_withdraw_approval":
        return (
          <WithdrawApprovalForm
            data={data}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        );
      case "add_account":
        return (
          <AddAccountForm user={user} onClose={onClose} onSuccess={onSuccess} />
        );
      case "transaction_withdraw_approval":
        return (
          <TransactionWithdrawApprovalForm
            user={user}
            data={data}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      sx={{ borderRadius: "30%" }}
    >
      <DialogTitle>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h6">{dialogLabel}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Divider sx={{ mt: 2 }} />
      </DialogTitle>

      <DialogContent>{renderForm()}</DialogContent>
    </Dialog>
  );
};

export default ActionDialog;
